export function validateEmail(email: string) {
  const emailRegex = /^[\w-]+(\.[\w-]+)*(\+[\w-]+)?(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
}
